import { type Ref, ref } from 'vue';
import { defineStore } from 'pinia';

// Definiere den Typ des PageSize-States
interface PageSizeState {
  pageSize: Ref<number>;
  setPageSize: (newPageSize: number) => void;
}

export const useTablePageSizeStore = defineStore<'tablePageSize', PageSizeState>(
  'tablePageSize',
  () => {
    const pageSize = ref<number>(10);

    function setPageSize(newPageSize: number) {
      pageSize.value = newPageSize;
    }

    return { pageSize, setPageSize };
  },
  {
    persist: true,
  },
);
